var DevicePlatform = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  MOBILEIOS: 'ios',
  APP: 'app',
  POPUP: 'popup'
}

export { DevicePlatform }
